import { render, staticRenderFns } from "./iSpringFinalCommentView.vue?vue&type=template&id=046ab29c&"
import script from "./iSpringFinalCommentView.vue?vue&type=script&lang=js&"
export * from "./iSpringFinalCommentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports